/* eslint-disable import/no-unresolved */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
import * as ActiveStorage from '@rails/activestorage';

import '../channels/consumer';

import 'jquery';
import 'bootstrap';
import 'admin-lte';
import '../javascripts/application';

Rails.start();
ActiveStorage.start();
